import { render, staticRenderFns } from "./PatientsTable.vue?vue&type=template&id=042ec709&"
import script from "./PatientsTable.vue?vue&type=script&lang=js&"
export * from "./PatientsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports